import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const yourNameSlice = createSlice({
  name: 'yourName',
  initialState: '',
  reducers: {
    yourNameUpdated: (_state, action: PayloadAction<string>) => action.payload,
  },
});

export const { yourNameUpdated } = yourNameSlice.actions;
export default yourNameSlice.reducer;
